'use client'

import { useTrack } from '@/hooks/useTrack'
import { SignedIn, UserButton } from '@clerk/nextjs'
import { Avatar } from '@mantine/core'

export function UserProfile() {
	const { track } = useTrack()
	return (
		<SignedIn>
			<div className="flex gap-2">
				{/* <Notifications /> */}
				<div
					onClick={() => {
						track('user_profile_clicked')
					}}
					className="hidden sm:flex"
				>
					<UserButton showName={false} fallback={<Avatar size="sm" />} />
				</div>
			</div>
		</SignedIn>
	)
}
